import { MsalContext } from '@azure/msal-react';
import React from 'react';
import { getInstances, publishApplication, replacePublishErrorTerms, updateProjectPortalConfig } from '../Helpers/Launch';
import { convertToJSDate } from '../Helpers/miscellaneous';
import moment from "moment";
import * as GenerationApi from "../../API/Generation/Generation";
import { getCompressedJson } from '../../API/Export/ExportApi';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { callApiWithAuthorization } from '../../API/CallApi';
import { createSearchParams, useNavigate } from 'react-router-dom';
import { bindShuffleMessageI18nEvents, messages } from '../Shared/ShuffleMessage/MessagesHelper';
import InProgressPublishDialog from './InProgressPublish';
import FailurePublishDialog from './FailurePublish';
import { getAzureUser } from "../../API/User/User";
import { updateProjectPropertiesAfterPublish } from '../../API/Project/project';

function withNavigate(Component) {
    function Wrapper(props) {
        const navigate = useNavigate();
        return (
            <Component
                {...props}
                navigate={navigate}
            />
        )
    }
    return Wrapper;
}

class PublishToRuntime extends React.Component {

    static contextType = MsalContext;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            url: "",
            showDisplayResetWarning: false,
            isPreviewPublished: false,
            instance: {},
            app: { status: "" },
            user: {},
            showCopySuccess: false,
            isProjectImported: false,
            _launchFunction: null,
            projectHasDisplayPages: false,
            error: "",
            hasSchemaError: false,
            showRepublishButton: false
        };
        bindShuffleMessageI18nEvents();
    }

    render() {
        if (this.state.app.status === "InProgress") {
            return (
                <InProgressPublishDialog
                    messages={
                        this.state.instance.instanceType === "Production" ?
                            this.state.instance.Published === true ? messages.updatePublish : messages.publish
                            :
                            this.state.instance.Published === true ? messages.updatePreview : messages.preview
                    }
                />
            )
        }
        if (this.state.app.status === "Failure") {
            return (
                <FailurePublishDialog
                    title={"Opps. Publish Error"}
                    error={this.state.error}
                    isShowFromWorkspace={false}
                    onClose={this.resetAppPublishDialog}
                />
            )
        }
        return (
            <>
                <div onClick={() => this.props.toggleDialog()} class="k-overlay"></div>
                <div className={this.props.forPreview ? "preview-panel-container border shadow-sm rounded" : "publish-panel-container border shadow-sm rounded"}>
                    {
                        this.state.loading &&
                        <div className="m-5 text-center">
                            <img
                                src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/designerresources/images/loaders/loader.gif`}
                                height={50}
                                alt="Loading"
                            />
                        </div>
                    }
                    {
                        this.state.showDisplayResetWarning &&
                        <Dialog
                            title={`${this.props.forPreview ? "Regenerate Preview" : "Republish App"}`}
                            onClose={this.toggleDisplayResetWarning}
                            width={"30%"}
                            className="generation-warning-dialog"
                            ref={(dialog) => {
                                if (dialog === null) {
                                    this._keepDropdownOpen = false
                                } else {
                                    dialog.element.addEventListener("click", this.handleInsideDialogClick)
                                }
                                this.displayResetWarningDialog = dialog;
                            }}
                        >
                            <div className='mt-3 dialog-content'>
                                {this.props.forPreview === true
                                    ? "If you proceed with auto generation, we will reset your preview instance to default configurations. All changes you previously applied to the preview instance might not be kept."
                                    : "If you proceed with auto generation, we will reset your publish instance to default configurations. All changes you previously applied to the publish instance might not be kept."}
                                <div className='mt-3'>Are you sure you want to proceed?</div>
                            </div>
                            <DialogActionsBar layout="end">
                                <div className="mb-3 me-3">
                                    <button
                                        autoFocus={true}
                                        className="btn btn-secondary"
                                        onClick={this.toggleDisplayResetWarning}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="btn btn-danger ms-2"
                                        onClick={this.launchWithFullGeneration}
                                    >
                                        Yes, Proceed
                                    </button>
                                </div>
                            </DialogActionsBar>
                        </Dialog>
                    }
                    {
                        (this.state.loading === false && this.state.app.status === "") &&
                        <div className="p-2">
                            <div className="py-2 pb-4">
                                <div className="d-center">
                                    <span className="mx-1">
                                        {this.props.forPreview ? "Preview" : "Publish"}  your app
                                    </span>
                                    {
                                        this.props.forPreview &&
                                        <Tooltip
                                            position="left"
                                            anchorElement="target"
                                            tooltipStyle={{ width: "300px" }}
                                        >
                                            <i
                                                title="You can preview and fine-tune your app in the Preview Instance. Once you are ready, you can choose to publish your app. Know more about App Preview, go to Help center."
                                                className="mx-2 fal fa-info-circle"
                                            ></i>
                                        </Tooltip>
                                    }
                                </div>
                            </div>

                            <div className="py-2">
                                <fieldset
                                    disabled={
                                        this.state.hasSchemaError ||
                                        this.state.app.status === "InProgress"
                                    }
                                >
                                    <div className='d-flex'>
                                        <button
                                            onClick={this.state._launchFunction}
                                            className={`btn btn-primary ${this.state.instance.Published === true && this.state.projectHasDisplayPages && "publish-button"}`}
                                            style={{
                                                borderTopRightRadius: 0,
                                                borderBottomRightRadius: 0,
                                                flex: 1
                                            }}
                                        >
                                            {this.getLaunchButtonText()}
                                        </button>
                                        {
                                            (
                                                this.state.instance.Published === true &&
                                                this.state.projectHasDisplayPages === true
                                            ) &&
                                            <button
                                                onClick={this.handleShowingRepublishButton}
                                                className="btn btn-primary publish-button-toggle"></button>
                                        }
                                    </div>
                                    {
                                        this.state.showRepublishButton &&
                                        (
                                            this.state.instance.Published === true ||
                                            this.state.projectHasDisplayPages === true
                                        ) && (
                                            <button
                                                onClick={this.toggleDisplayResetWarning}
                                                className="mt-2 btn btn-secondary w-100"
                                                disabled={
                                                    this.state.hasSchemaError ||
                                                    this.state.app.status === "InProgress"
                                                }
                                            >
                                                {this.props.forPreview
                                                    ? "Regenerate "
                                                    : "Republish "}
                                                {this.props.forPreview ? "Preview" : "App"}
                                            </button>
                                        )
                                    }
                                </fieldset>
                            </div>

                            <div>
                                {this.state.instance.Published === true &&
                                    <div className="py-2">
                                        <div className="text-center">
                                            <a
                                                rel="noreferrer"
                                                href={this.state.url}
                                                className="btn btn-link text-primary text-decoration-none"
                                                target="_blank"
                                                ref={hyperlink => this.runtimeLink = hyperlink}
                                            >
                                                <span className="text-link">
                                                    Go to App Workspace {this.props.forPreview && "(Preview)"}
                                                </span>
                                                <i className="mx-1 fas fa-external-link"></i>
                                            </a>

                                            {!this.state.showCopySuccess && (
                                                <button
                                                    className="btn btn-link text-decoration-none text-dark"
                                                    onClick={this.copyLink}
                                                >
                                                    <i className="far fa-copy"></i>
                                                </button>
                                            )}
                                            {this.state.showCopySuccess && (
                                                <small className="text-success">
                                                    <i className="far fa-check-circle"></i>
                                                    Copied
                                                </small>
                                            )}
                                        </div>
                                        <small className="pt-2 d-center">
                                            <span>Last published time</span>
                                            <span className="mx-1">
                                                {this.state.instance.updatedDate}
                                            </span>
                                        </small>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            </>
        )
    }



    async componentDidMount() {
        const { projectId } = this.props;

        const [instances, project, validationResult] = await Promise.all([
            getInstances(projectId),
            this.getProject(projectId),
            this.validateForPublish(),
        ]);

        const instanceType = this.getInstanceType();
        const instance = instances.find(
            (instance) => instance.instanceType === instanceType
        );

        const isProjectImported = project.isImported === "true";

        const dateInfo = convertToJSDate(instance.updatedDate);
        const date = new Date(Date.UTC(...dateInfo));
        instance.updatedDate = moment(date).format("LLL");

        let { error } = instance;
        let { app } = this.state

        if (instance.error === undefined) {
            error = "";
        }

        const hasSchemaError = validationResult.error !== undefined;
        if (validationResult.error) {
            error = validationResult.error;
            app.status = "Failure"
        }

        const organization = this.props.organizations.find((org) => org.number === this.props.orgName);

        let projectURL = this.props.projectUrl + "_" + instance.id.slice(0, 5);
        let defaultPortalUrl = project.defaultPortal && project.defaultPortal.length > 0 ? project.defaultPortal[0].urlName : ""
        let url = `${process.env.REACT_APP_RUNTIME_URL}/${organization.url}/${projectURL}/${defaultPortalUrl}`

        this.props.setUrl(url);
        this.props.setLastPublishedInstance(instance);

        this.setState(
            {
                instance,
                isProjectImported,
                error,
                url,
                hasSchemaError,
                user: this.props.user,
                app,
            },
            async () => {
                const projectHasDisplayPages =
                    await this.checkIfProjectHasDisplayPages();
                const _launchFunction = this.getLaunchFunction(
                    projectHasDisplayPages
                );
                this.setState({
                    _launchFunction,
                    projectHasDisplayPages,
                    loading: false,
                });
            }
        );
    }

    getProject = async (projectId) => {
        const request = await callApiWithAuthorization("/api/v0/getLibraryProject/" + projectId);
        const result = await request.json();
        return result
    }

    getInstanceType() {
        return "Production";
    }

    getLaunchButtonText() {
        const { forPreview } = this.props;
        const { instance } = this.state;
        if (instance.Published === true) {
            if (forPreview) {
                return "Update Preview";
            } else {
                return "Update App";
            }
        } else {
            if (forPreview) {
                return "Preview App";
            } else {
                return "Publish App";
            }
        }
    }

    handleShowingRepublishButton = (e) => {
        this.setState({
            showRepublishButton: !this.state.showRepublishButton
        })
    }

    validateForPublish = async () => {
        const instanceType = this.getInstanceType().toLowerCase();
        const { projectId } = this.props;
        console.time("validateForPublish")
        const request = await callApiWithAuthorization(
            "/api/v0/project/" + projectId + "/validateForPublish",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    instanceType,
                    projectId,
                }),
            }
        );
        const response = await request.json();
        console.timeEnd("validateForPublish")
        return response;
    };

    setLaunchFunction = async (launchFunction) => {
        this._launchFunction = launchFunction;
    };

    getLaunchFunction = (projectHasDisplayPages) => {
        if (projectHasDisplayPages) {
            return this.launchWithIncrementalPreview;
        }
        return this.launchWithFullGeneration;
    };

    checkIfProjectHasDisplayPages = async () => {
        const { projectId } = this.props;
        const request = await callApiWithAuthorization(
            "/api/v0/project/" + projectId + "/hasDisplayPages"
        );
        const response = await request.json();
        const { hasPages } = response;
        return hasPages;
    };

    togglePublishing = async (value) => {
        this.setState({
            app: {
                status: value
            }
        })
    }

    toggleMenu = () => {
        this.setState({
            showOtherOptions: !this.state.showOtherOptions,
        });
    };

    showSuccess = (publishResult) => {
        const { data } = publishResult;
        const newInstanceData = {
            ...this.state.instance,
            Published: true,
            lastUpdatedDate: new Date(),
        };
        this.setState({
            app: {
                status: publishResult.status
            },
            instance: newInstanceData,
        })
        if (data.appUrl) {
            try {
                window.open(this.state.url, "_blank").focus();
            } catch (e) {
                //
            }
        }
        return newInstanceData;
    };

    openRuntimeInNewTab = (instance) => {
        const { Url } = instance;
        window.open(Url, "_blank").focus();
    }

    resetAppPublishDialog = () => {
        this.setState({
            app: {
                status: "reset"
            }
        })
        this.props.toggleDialog()
    }

    copyLink = () => {
        navigator.clipboard.writeText(this.state.instance.Url);
        this.setState(
            {
                showCopySuccess: true,
            },
            () => {
                setTimeout(() => {
                    this.setState({
                        showCopySuccess: false,
                    });
                }, 2000);
            }
        );
    };

    launchWithIncrementalPreview = (event) => {
        event.stopPropagation();
        this.togglePublishing("InProgress")
            .then(this.performIncrementalGeneration)
            .then(this.publishJsonToRuntime)
            .then(this.showSuccess)
            .then(this.updateLaunchFunction)
            .then(this.toggleDialogIfApplicable)
            .catch(this.showErrorMessage);
    };

    toggleDisplayResetWarning = (e) => {
        this.setState({
            showDisplayResetWarning: !this.state.showDisplayResetWarning,
        });
    };

    hideDisplayResetWarningIfVisible = () => {
        if (this.state.showDisplayResetWarning) {
            this.toggleDisplayResetWarning();
        }
    };

    launchWithFullGeneration = (event) => {
        event.stopPropagation();
        this.togglePublishing("InProgress")
            .then(this.hideDisplayResetWarningIfVisible)
            .then(this.performFullGeneration)
            .then(this.getCompressedJson)
            .then(this.publishJsonToRuntime)
            .then(this.updateInstanceProperties)
            .then(this.showSuccess)
            // .then(this.openRuntimeInNewTab)
            .then(this.refreshPage)
            .catch(this.showErrorMessage)
    };

    updateLaunchFunction = async () => {
        const projectHasDisplayPages =
            await this.checkIfProjectHasDisplayPages();
        const _launchFunction = this.getLaunchFunction(projectHasDisplayPages);
        this.setState({
            projectHasDisplayPages,
            _launchFunction,
        });
    };

    showErrorMessage = (err) => {
        this.setState({
            error: err.message,
            app: { status: "Failure" }
        });
    };

    toggleDialogIfApplicable = () => {
        this.togglePublishing("");
        if (this.state.error === "") {
            if (this.state.user.showSuccessDialog === "true") {
                this.props.showSuccess();
            }
            this.props.toggleDialog();
        }
    }

    performIncrementalGeneration = async () => {
        const { projectId, forPreview } = this.props;

        let user = await getAzureUser(this.context);

        const userId = user.oid

        const organization = this.props.organizations.find((org) => org.number === this.props.orgName);

        const [compressedJson, generationError] =
            await GenerationApi.generateIncrementalChanges(
                projectId,
                organization.id,
                userId,
                this.state.instance.id,
                forPreview,
                false
            );

        await callApiWithAuthorization(
            "/api/v0/project/" +
            this.props.projectId +
            "/removeAllChanges",
            {
                method: "DELETE",
            }
        );

        return compressedJson;
    };

    performFullGeneration = async () => {
        const { projectId } = this.props;

        await GenerationApi.removePortalCreatedPages(projectId);
        await GenerationApi.removePortalItems(projectId);

        const [generationResponse, generationError] =
            await GenerationApi.generatePageConfiguration(projectId);

        if (generationError !== null) {
            throw new Error(generationError);
        }

        await GenerationApi.removePlaceholderLinks(projectId);

        await callApiWithAuthorization(
            "/api/v0/project/" +
            this.props.projectId +
            "/removeAllChanges",
            {
                method: "DELETE",
            }
        );
    };

    getCompressedJson = async () => {
        const { context } = this;

        const user = await getAzureUser(context);

        const userId = user.oid;

        const { projectId, forPreview, orgName } = this.props;

        const organization = this.props.organizations.find((org) => org.number === orgName)

        const compressedJson = await getCompressedJson(
            projectId,
            organization.id,
            userId,
            this.state.instance.id,
            forPreview,
            false
        );

        return compressedJson;
    };

    publishJsonToRuntime = async (compressedJson) => {
        const { projectId } = this.props;
        const { instance } = this.state;

        updateProjectPortalConfig(projectId);

        console.time("runtime");

        const isFirstTimePublish = instance.Published === false;
        let result = await publishApplication(
            this.context,
            instance,
            compressedJson,
            isFirstTimePublish
        );

        console.timeEnd("runtime");

        if (result.status === "Failure") {
            throw new Error(replacePublishErrorTerms(result.message));
        }

        await updateProjectPropertiesAfterPublish(projectId, instance._id)

        return result;
    };

    updateInstanceProperties = (result) => {
        const instance = { ...this.state.instance };
        instance.Published = true;
        instance.isDbChanged = false;
        this.setState({ instance });
        return result;
    };

    refreshPage = () => {
        const searchParams = {
            showSuccessfulPublishDialog: this.state.user.showSuccessDialog === "true",
            instanceId: this.state.instance.id,
            url: this.state.url
        }
        const search = searchParams.showSuccessfulPublishDialog ? createSearchParams(searchParams).toString() : "";
        this.props.navigate({
            path: ".",
            search
        })
        window.location.reload();
    };
}

export default withNavigate(PublishToRuntime);